import { render, staticRenderFns } from "./myAuditSections.vue?vue&type=template&id=8b606a7c&"
import script from "./myAuditSections.vue?vue&type=script&lang=js&"
export * from "./myAuditSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports